module.exports = __webpack_public_path__ + "img/solution_traffic1.ac3a0b1c.png";